import { memo, useEffect, useState, useRef } from 'react';
import DragDrawer from '@/components/drag-drawer';
import DrawerToast from '../qa-drawer/components/drawer-toast';
import QuestionDetail from '@/components/question-detail';
import { getGlobalStore } from '@/store/global';
import { getQaStore } from '@/store/qa';
import { recoverBodyScroll, stopBodyScroll } from '@/utils';

const QaDetailDrawer = () => {
    const [qaInfo, setQaInfo] = useState<{ type: 'pair_of_qa' | 'gbot'; id: number }>();
    const [visible, setVisible] = useState(false);
    const callbacksRef = useRef<Record<string, () => void>>();

    const handleCloseDrawer = () => {
        setVisible(false);
        // 延迟清空数据
        setTimeout(() => setQaInfo(undefined), 500);
        getQaStore()?.updateQaConfig({ canExcuteAimation: false });
        callbacksRef.current?.onCloseDrawer();
    };

    useEffect(() => {
        getGlobalStore()?.subscribe('QaDetailDrawer', ({ type, params, callbacks }) => {
            switch (type) {
                case 'open':
                    callbacksRef.current = callbacks;
                    setVisible(true);
                    setQaInfo(params);
                    setTimeout(() => {
                        getQaStore()?.updateQaConfig({ canExcuteAimation: true });
                    }, 500);
                    break;
                default:
                    handleCloseDrawer();
                    break;
            }
        });
    }, []);

    useEffect(() => {
        visible ? stopBodyScroll() : recoverBodyScroll();
    }, [visible]);

    return (
        <DragDrawer width={375} open={visible} onClose={handleCloseDrawer}>
            {qaInfo && (
                <>
                    <QuestionDetail
                        type={qaInfo.type === 'pair_of_qa' ? 'pair_of_qa' : 'gbot'}
                        id={qaInfo.id}
                        onClose={handleCloseDrawer}
                    />
                    <DrawerToast />
                </>
            )}
        </DragDrawer>
    );
};

export default memo(QaDetailDrawer);
